
import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { GetAllCentroCustoListaRequest, GetAllCentroCustoListaResponse } from "../daos/read/get_all_centro_custo_lista";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { IComercialService } from "./comercial_service";
import { EmpreendimentoBlocoTableRequest, EmpreendimentoBlocoTableResponse } from "../daos/read/get_empreendimento_bloco_table";
import { EmpreendimentoBlocoDropDownDao, EmpreendimentoBlocoDropDownResponse } from "../daos/read/get_empreendimento_bloco_drop_down";
import { DeleteCentroCustoByIdRequest, DeleteCentroCustoByIdResponse } from '../daos/delete/delete_centro_custo_by_id';
import { CreateCentroCustoRequest, CreateCentroCustoResponse } from '../daos/create/create_centro_custo';
import { UpdateCentroCustoRequest, UpdateCentroCustoResponse } from '../daos/update/update_centro_custo';
import { GetCentroCustoResponse } from '../daos/read/get_centro_custo';
import { UpdateInformacaoFaturamentoRequest, UpdateInformacaoFaturamentoResponse } from '../daos/update/update_informacao_faturamento';
import { CreateInformacaoFaturamentoRequest, CreateInformacaoFaturamentoResponse } from '../daos/create/create_informacao_faturamento';
import { DeleteInformacaoFaturamentoRequest, DeleteInformacaoFaturamentoResponse } from '../daos/delete/delete_informacao_faturamento';
import { GetInformacaoFaturamentoRequest, GetInformacaoFaturamentoResponse } from '../daos/read/get_informacao_faturamento';
import { GetAllInformacaoFaturamentoRequest, GetAllInformacaoFaturamentoResponse } from '../daos/read/get_all_informacao_faturamento';
import { GetClienteByIdRequest, GetClienteByIdResponse } from '../daos/read/get_cliente_by_id';
import { CreateCentroCustoEnderecoRequest, CreateCentroCustoEnderecoResponse } from '../daos/create/create_centro_custo_endereco';
import { UpdateCentroCustoEnderecoRequest, UpdateCentroCustoEnderecoResponse } from '../daos/update/update_centro_custo_endereco';
import { DeleteCentroCustoEnderecoRequest, DeleteCentroCustoEnderecoResponse } from '../daos/delete/delete_centro_custo_endereco';
import { GetCentroCustoEnderecoRequest, GetCentroCustoEnderecoResponse } from '../daos/read/get_centro_custo_endereco';
import { GetAllCentroCustoEnderecoRequest, GetAllCentroCustoEnderecoResponse } from '../daos/read/get_all_centro_custo_endereco';
import { GetAllClienteRequest, GetAllClienteResponse } from "../daos/read/get_all_cliente";
import { CreateClienteRequest, CreateClienteResponse } from "../daos/create/create_cliente";
import { UpdateClienteRequest, UpdateClienteResponse } from "../daos/update/update_cliente";
import { GetClienteCentroCustoByIdRequest, GetClienteCentroCustoByIdResponse } from "../daos/read/get_cliente_centro_custo_by_id";
import { GetAllClienteCentroCustoRequest, GetAllClienteCentroCustoResponse } from '../daos/read/get_all_cliente_centro_custo';
import { CreateClienteCentroCustoRequest, CreateClienteCentroCustoResponse } from '../daos/create/create_cliente_centro_custo';
import { UpdateClienteCentroCustoRequest, UpdateClienteCentroCustoResponse } from '../daos/update/update_cliente_centro_custo';
import { GetClienteArquivoByIdResponse } from '../daos/read/get_cliente_arquivo_by_id';
import { GetAllClienteArquivoRequest, GetAllClienteArquivoResponse } from '../daos/read/get_all_cliente_arquivo';
import { CreateClienteArquivoRequest, CreateClienteArquivoResponse } from '../daos/create/create_cliente_arquivo';
import { UpdateClienteArquivoRequest, UpdateClienteArquivoResponse } from '../daos/update/update_cliente_arquivo';
import { GetNovosNegociosByIdRequest, GetNovosNegociosByIdResponse } from "../daos/read/get_novos_negocios_by_id";
import { GetAllNovosNegociosRequest, GetAllNovosNegociosResponse } from "../daos/read/get_all_novos_negocios";
import { CreateNovosNegociosRequest, CreateNovosNegociosResponse } from "../daos/create/create_novos_negocios";
import { UpdateNovosNegociosRequest, UpdateNovosNegociosResponse } from "../daos/update/update_novos_negocios";
import { GetNovosNegociosArquivoByIdRequest } from "../daos/read/get_novos_negocios_arquivo_by_id";
import { GetAllNovosNegociosArquivoRequest, GetAllNovosNegociosArquivoResponse } from "../daos/read/get_all_novos_negocios_arquivo";
import { CreateNovosNegociosArquivoRequest, CreateNovosNegociosArquivoResponse } from "../daos/create/create_novos_negocios_arquivo";
import { UpdateNovosNegociosArquivoRequest, UpdateNovosNegociosArquivoResponse } from "../daos/update/update_novos_negocios_arquivo";
import { SendEmailNovosNegociosRequest, SendEmailNovosNegociosResponse } from "../daos/read/send_email_novos_negocios";
import { GetSubcontasByIdRequest, GetSubcontasByIdResponse } from "../daos/read/get_subcontas_by_id";
import { GetAllSubcontasRequest, GetAllSubcontasResponse } from "../daos/read/get_all_subcontas";
import { UpdateSubcontasRequest, UpdateSubcontasResponse } from "../daos/update/update_subcontas";
import { CreateSubcontasRequest, CreateSubcontasResponse } from "../daos/create/create_subcontas";
import { DownloadNovosNegociosArquivoRequest, DownloadNovosNegociosArquivoResponse } from "../daos/read/download_novos_negocios_arquivo";
import { GetDashboardComercialInformationRequest, GetDashboardComercialInformationResponse } from "../daos/read/get_dashboard_comercial_information";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { DownloadArquivoS3Request } from "../../../../common/data/daos/read/downloadArquivoS3";



/**
 * ComercialService
 */
export class ComercialService implements IComercialService {

    //#region  Centro Custo

    async getAllCentroCustoLista(request: GetAllCentroCustoListaRequest): Promise<GetAllCentroCustoListaResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/centrocustos/lista`, request);
            const response = handleAxiosResponse<GetAllCentroCustoListaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async getCentroCustoById(idCentroCusto: number): Promise<GetCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/centrocusto/${idCentroCusto}`);
            const response = handleAxiosResponse<GetCentroCustoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getEmpreendimentoBlocoTable(request: EmpreendimentoBlocoTableRequest): Promise<EmpreendimentoBlocoTableResponse[]> {
        try {
            const result = await axiosInstance({}).post(`/comercial/empreendimento/blocotable`, request.idBlocos);
            const response = handleAxiosResponse<EmpreendimentoBlocoTableResponse[]>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getEmpreendimentoBlocoDropDown(idEmpreendimento: number): Promise<EmpreendimentoBlocoDropDownResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/empreendimento/blocodropdown/${idEmpreendimento}`,);
            const response = handleAxiosResponse<EmpreendimentoBlocoDropDownDao[]>(result);
            return { item: [...response] };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteCentroCustoById(request: DeleteCentroCustoByIdRequest): Promise<DeleteCentroCustoByIdResponse> {

        try {
            const result = await axiosInstance({}).get(`/comercial/centrocusto/delete/${request.idCentroCusto}`);
            const response = handleAxiosResponse<DeleteCentroCustoByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createCentroCusto(request: CreateCentroCustoRequest): Promise<CreateCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/centrocusto/create`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateCentroCusto(request: UpdateCentroCustoRequest): Promise<UpdateCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/centrocusto/update`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createInformacaoFaturamento(request: CreateInformacaoFaturamentoRequest): Promise<CreateInformacaoFaturamentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/informacaofaturamento/create`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateInformacaoFaturamento(request: UpdateInformacaoFaturamentoRequest): Promise<UpdateInformacaoFaturamentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/informacaofaturamento/update`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteInformacaoFaturamento(request: DeleteInformacaoFaturamentoRequest): Promise<DeleteInformacaoFaturamentoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/informacaofaturamento/delete/${request.idInformacaoFaturamento}`);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getInformacaoFaturamento(request: GetInformacaoFaturamentoRequest): Promise<GetInformacaoFaturamentoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/informacaofaturamento/${request.idInformacaoFaturamento}`);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getInformacaoFaturamentoList(request: GetAllInformacaoFaturamentoRequest): Promise<GetAllInformacaoFaturamentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/informacaofaturamento/all`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };



    async createCentroCustoEndereco(request: CreateCentroCustoEnderecoRequest): Promise<CreateCentroCustoEnderecoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/centrocustoendereco/create`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async updateCentroCustoEndereco(request: UpdateCentroCustoEnderecoRequest): Promise<UpdateCentroCustoEnderecoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/centrocustoendereco/update`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async deleteCentroCustoEndereco(request: DeleteCentroCustoEnderecoRequest): Promise<DeleteCentroCustoEnderecoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/centrocustoendereco/delete/${request.idCentroCustoEndereco}`);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async getCentroCustoEnderecoById(request: GetCentroCustoEnderecoRequest): Promise<GetCentroCustoEnderecoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/centrocustoendereco/${request.idCentroCustoEndereco}`);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    async getAllCentroCustoEndereco(request: GetAllCentroCustoEnderecoRequest): Promise<GetAllCentroCustoEnderecoResponse> {
        try {

            const result = await axiosInstance({}).post(`/comercial/centrocustoendereco/getall`, request);
            const response = handleAxiosResponse(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };


    //#endregion





    //#region  Cliente
    async getClienteById(request: GetClienteByIdRequest): Promise<GetClienteByIdRequest> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/${request.idCliente}`);
            const response = handleAxiosResponse<GetClienteByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllClienteLista(request: GetAllClienteRequest): Promise<GetAllClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/clientes/lista`, request);
            const response = handleAxiosResponse<GetAllClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteClienteById(idCliente: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/delete/${idCliente}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createCliente(form: CreateClienteRequest): Promise<CreateClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/create`, form);
            const response = handleAxiosResponse<CreateClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateCliente(form: UpdateClienteRequest): Promise<UpdateClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/update`, form);
            const response = handleAxiosResponse<UpdateClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion




    //#region  Cliente Centro Custo
    async getClienteCentroCustoById(request: GetClienteCentroCustoByIdRequest): Promise<GetClienteCentroCustoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/unidade/${request.idClienteCentroCusto}`);
            const response = handleAxiosResponse<GetClienteCentroCustoByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllClienteCentroCustoLista(request: GetAllClienteCentroCustoRequest): Promise<GetAllClienteCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/unidade/lista`, request);
            const response = handleAxiosResponse<GetAllClienteCentroCustoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteClienteCentroCustoById(idClienteCentroCusto: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/unidade/delete/${idClienteCentroCusto}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createClienteCentroCusto(form: CreateClienteCentroCustoRequest): Promise<CreateClienteCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/unidade/create`, form);
            const response = handleAxiosResponse<CreateClienteCentroCustoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateClienteCentroCusto(form: UpdateClienteCentroCustoRequest): Promise<UpdateClienteCentroCustoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/unidade/update`, form);
            const response = handleAxiosResponse<UpdateClienteCentroCustoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion

    //#region  Cliente Arquivo

    async getClienteArquivoById(request: GetClienteArquivoByIdResponse): Promise<GetClienteArquivoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/arquivo/${request.idClienteArquivo}`);
            const response = handleAxiosResponse<GetClienteArquivoByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllClienteArquivoLista(request: GetAllClienteArquivoRequest): Promise<GetAllClienteArquivoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/cliente/arquivo/lista`, request);
            const response = handleAxiosResponse<GetAllClienteArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteClienteArquivoById(idClienteArquivo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/cliente/arquivo/delete/${idClienteArquivo}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createClienteArquivo(request: CreateClienteArquivoRequest): Promise<CreateClienteArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/comercial/cliente/arquivo/create`, formData, options);
            const response = handleAxiosResponse<CreateClienteArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateClienteArquivo(request: UpdateClienteArquivoRequest): Promise<UpdateClienteArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/comercial/cliente/arquivo/update`, formData, options);
            const response = handleAxiosResponse<UpdateClienteArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }

    };

    async downloadClienteArquivoS3({ id }: DownloadArquivoS3Request): Promise<Blob> {
        try {
            const result = await axiosInstance({ responseType: 'blob' }).get(`/comercial/cliente/arquivo/download/${id}`);
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    //#endregion


    //#region Novos Negócios
    async getNovosNegociosById(request: GetNovosNegociosByIdRequest): Promise<GetNovosNegociosByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/novosnegocios/${request.idNovosNegocios}`);
            const response = handleAxiosResponse<GetNovosNegociosByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllNovosNegociosLista(request: GetAllNovosNegociosRequest): Promise<GetAllNovosNegociosResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/novosnegocios/lista`, request);
            const response = handleAxiosResponse<GetAllNovosNegociosResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteNovosNegociosById(idNovosNegocios: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/novosnegocios/delete/${idNovosNegocios}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createNovosNegocios(form: CreateNovosNegociosRequest): Promise<CreateNovosNegociosResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/novosnegocios/create`, form);
            const response = handleAxiosResponse<CreateNovosNegociosResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateNovosNegocios(form: UpdateNovosNegociosRequest): Promise<UpdateNovosNegociosResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/novosnegocios/update`, form);
            const response = handleAxiosResponse<UpdateNovosNegociosResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async sendEmailNovosNegocios(request: SendEmailNovosNegociosRequest): Promise<SendEmailNovosNegociosResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/novosnegocios/${request.idNovosNegocios}/send-email`, request);
            const response = handleAxiosResponse<SendEmailNovosNegociosResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion

    //#region Novos Negocios Arquivo
    async getNovosNegociosArquivoById(request: GetNovosNegociosArquivoByIdRequest): Promise<Blob> {
        try {
            const result = await axiosInstance({ responseType: 'blob' }).get(`/comercial/novosnegocios-arquivo/${request.idNovosNegociosArquivo}`);
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllNovosNegociosArquivoLista(request: GetAllNovosNegociosArquivoRequest): Promise<GetAllNovosNegociosArquivoResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/novosnegocios-arquivo/lista`, request);
            const response = handleAxiosResponse<GetAllNovosNegociosArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteNovosNegociosArquivoById(idNovosNegociosArquivo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/novosnegocios-arquivo/delete/${idNovosNegociosArquivo}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createNovosNegociosArquivo(form: CreateNovosNegociosArquivoRequest): Promise<CreateNovosNegociosArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(form);
            const options = { headers: { 'Content-Type': 'multipart/form-data' } };
            const result = await axiosInstance({}).post(`/comercial/novosnegocios-arquivo/create`, formData, options);
            const response = handleAxiosResponse<CreateNovosNegociosArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateNovosNegociosArquivo(form: UpdateNovosNegociosArquivoRequest): Promise<UpdateNovosNegociosArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(form);
            const options = { headers: { 'Content-Type': 'multipart/form-data' } };
            const result = await axiosInstance({}).post(`/comercial/novosnegocios-arquivo/update`, formData, options);
            const response = handleAxiosResponse<UpdateNovosNegociosArquivoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion




    //#region Subconta 
    async getSubcontaById(request: GetSubcontasByIdRequest): Promise<GetSubcontasByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/subcontas/${request.idSubconta}`);
            const response = handleAxiosResponse<GetSubcontasByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllSubcontas(request: GetAllSubcontasRequest): Promise<GetAllSubcontasResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/subcontas/all`, request);
            const response = handleAxiosResponse<GetAllSubcontasResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteSubcontaById(idSubconta: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/comercial/subcontas/delete/${idSubconta}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createSubconta(request: CreateSubcontasRequest): Promise<CreateSubcontasResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/subcontas/create`, request);
            const response = handleAxiosResponse<CreateSubcontasResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateSubconta(request: UpdateSubcontasRequest): Promise<UpdateSubcontasResponse> {
        try {
            const result = await axiosInstance({}).post(`/comercial/subcontas/update`, request);
            const response = handleAxiosResponse<UpdateSubcontasResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion

    async downloadNovosNegociosArquivo({ idNovosNegocios }: DownloadNovosNegociosArquivoRequest): Promise<DownloadNovosNegociosArquivoResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/novosnegocios/${idNovosNegocios}/download-arquivo`);
            const response = handleAxiosResponse<DownloadNovosNegociosArquivoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getDashboardComercialInformation(request: GetDashboardComercialInformationRequest): Promise<GetDashboardComercialInformationResponse> {
        try {
            const result = await axiosInstance({}).get(`/comercial/dashboard/information`);
            const response = handleAxiosResponse<GetDashboardComercialInformationResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }
}

